var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classNames,style:(_vm.styles),attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.clickEvent($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }